// src/components/common/SolutionListSection.tsx

import React from "react";
import { appData } from "../../data/appData";
import { HeroSectionData, TextSectionData, FeatureSectionData } from "../../types/interfaces";
import FeatureSection from "./FeatureSection";

const SolutionListSection: React.FC = () => {
  const solutions = appData.pages.solutionDetails;

  return (
    <div className="solution-list-section">
      {solutions.map((solution, index) => {
        // Find the HeroSection and TextSection for each solution
        const heroSection = solution.sections.find(
          (section) => section.type === "HeroSection"
        ) as HeroSectionData | undefined;

        const textSection = solution.sections.find(
          (section) => section.type === "TextSection"
        ) as TextSectionData | undefined;

        if (heroSection && textSection) {
          const featureData: FeatureSectionData = {
            type: "FeatureSection",
            title: heroSection.title,
            description: textSection.content.replace(/<\/?[^>]+(>|$)/g, ""), // Remove HTML tags
            image: heroSection.image,
            ctaText: "Learn More",
            imagePosition: index % 2 === 0 ? "left" : "right",
            id: solution.id, // Solution ID to link to details page
            pageType: "solutions", // Assuming 'solutions' is the pageType
            ctaLink: "", // If you have specific links, set them here
          };

          return <FeatureSection key={index} {...featureData} />;
        } else {
          // Log missing data for debugging if a solution doesn't render
          console.warn(`Solution with ID ${solution.id} is missing required sections.`);
          return null;
        }
      })}
    </div>
  );
};

export default SolutionListSection;
